const topHeight = (target) =>
  document.querySelector(target)?.getBoundingClientRect().top +
  document.documentElement.scrollTop

const additionalOffset = () =>
  parseInt(window.SAXX.Init.AdditionalScrollToOffset(), 10) || 0

const headerHeight = () =>
  document.querySelector('.site-navigation').clientHeight

export const scrollToHandler = (hash) => {
  window.scrollTo({
    top: topHeight(hash) - additionalOffset() - headerHeight() - 16,
    left: 0,
    behavior: 'smooth',
  })
}
